/* eslint-disable @typescript-eslint/no-this-alias */
import * as Sentry from '@sentry/browser';
import $ from 'jquery';

import { FingerPrint } from '../fingerPrint';
import {
  DEBUG_MODE,
  getScreenMode,
  getUrlCheckAccess,
  switchScreenMode,
} from '../spdConfig';

import { ActiveStep } from './activeStep';
import { Announcement } from './announcement';
import { signOut } from './auth';
import { FooterTools } from './footerTools';
import { FullScreen } from './fullScreen';
import { Loader, LoaderError } from './loader';
import { MySound, SoundParam } from './sound';
import { SPDEngineGateway } from './spdEngineGateway';
import { Speaker } from './speaker';
import { SupervisorMonitor } from './supervisorMonitor';
import * as Configuration from './testConfiguration';

declare let speaker: Speaker;
declare let supervisorMonitor: SupervisorMonitor;
declare let testConfiguration: Configuration.TestConfiguration;

export class SPDPageGateway extends SPDEngineGateway {
  public speakText(text: string, sound: string, must_read = false) {
    speaker.stopSoundOrSpeakText();
    void speaker.playSoundOrSpeakText(text, must_read, sound);
  }

  public enter(event: JQuery.KeyPressEvent, callback: () => void) {
    if (event.key === 'Enter') {
      callback && callback();
    }
  }

  public focus(id: string) {
    $('#' + id).trigger('focus');
  }

  protected async checkDeviceAccess() {
    try {
      const access = await Loader.getSyncJSONWithVersion(
        getUrlCheckAccess(FingerPrint.getFingerPrint()),
        null,
        true,
      );
      DEBUG_MODE && console.log('checkDeviceAccess', access);
      if (!access) {
        Announcement.announcementAbout('wrong_device', true);
      }
      return access;
    } catch (e) {
      Sentry.captureException(e);
      Announcement.announcementAbout(
        'error_device',
        false,
        (e as LoaderError).message,
      );
      return false;
    }
  }

  public changeLange() {
    const lange = $('#tools_lange').val() as Configuration.Lange;
    const changed = testConfiguration.lange !== lange;
    testConfiguration.lange = lange;

    changed && ActiveStep.reloadActiveStep();
    changed && speaker.setLange(lange);
    supervisorMonitor.setLange(testConfiguration.lange);
  }

  public speakerOnOff() {
    speaker.switchOnOff();
    FooterTools.setSpeakerIcon();
    speaker.isON() && ActiveStep.reloadActiveStep();
  }

  public async help(event: Event) {
    try {
      event.stopPropagation();
      const text = 'call_local_supervisor'; //'no_connection';
      /* wyłączona funkcjonalność, pozostaje jedynie oznaczenie na oknie czatu i wyświetlenie komunikatu
        if (!runLocalTest()) {
        await Loader.patch(getUrlAlarm() + this.survey?.getId(), {
          alarm: true,
        });
        text = 'call_help';
      }*/
      void supervisorMonitor.sendCallForHelp();
      Announcement.announcementAbout(text);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
    }
  }

  public async logout() {
    await signOut();
  }

  public loadCSSMode() {
    FooterTools.setModeIcon(getScreenMode());
    const param = new Date().toISOString();
    if (getScreenMode()) {
      $('body').removeClass('mode-dark');
      $('body').addClass('mode-normal');
      Loader.loadCSS('./css/mode.css?' + param, 'mode_css');
    } else {
      $('body').removeClass('mode-normal');
      $('body').addClass('mode-dark');
      Loader.loadCSS('./css/mode-dark.css?' + param, 'mode_css');
    }
  }

  public switchCSSMode() {
    switchScreenMode();
    this.loadCSSMode();
  }

  public async openFullscreen() {
    DEBUG_MODE && console.log('openFullscreen');
    await FullScreen.openFullscreen();
  }

  public async playSound(sound: SoundParam) {
    if (sound) {
      await MySound.playSound(sound);
    }
  }
}
